import { title } from '../config/constants'

export function pageLoaded(pageTitle) {
  document.title = `${pageTitle} - ${title}`
}



// WEBPACK FOOTER //
// ./src/screens/utils.js